import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const FilterControlsWrapper = styled.div`
  @media (min-width: 1024px) {
    height: 54px;
  }
  @media (max-width: 767px) {
    > div {
      width: 100%;
      > div {
        width: 100%;
        &.action_container {
          width: auto;
        }
      }
    }
  }

  .search-container {
    width: 100%;
    @media (min-width: 1024px) {
      height: 54px;
    }
    @media (max-width: 767px) {
      /* Top & bottom padding only, align horizontally with content */
      padding: 12px 0;
      /* Allow children to share the row without forcing full-width */
      > div {
        width: auto;
      }
      > div:first-child {
        align-items: flex-start !important;
        gap: 12px !important;
      }
      .title-filter-wrapper {
        width: 100%;
        flex-basis: 100%;
        .mantine-Select-root {
          width: 100% !important;
          input {
            width: 100% !important;
          }
        }
      }
    }
    .searchWrapper {
      /* Let the search input take remaining space on the row */
      flex: 1 1 0;
      min-width: 0;
      max-width: 100%;
      width: auto;
    }
    .search_wrappeer {
      border-radius: 8px;
      background-color: ${theme.colours.white};
      width: 100%;
      .mantine-Input-rightSection {
        right: initial;
        cursor: pointer;
      }
      .mantine-Autocomplete-icon {
        right: 0 !important;
        left: unset !important;
      }
      input {
        font-family: ${theme.fonts.Medium};
        border: 0.5px solid ${theme.colours.newOutline};
        border-radius: 8px;
        padding-right: 0;
        font-size: 14px;
        height: 30px !important;
        min-height: 30px !important;
        ::placeholder {
          color: ${theme.colours.silverChalice};
          font-size: 14px;
        }
        @media (max-width: 767px) {
          width: 100%;
        }
        &:lang(en) {
          text-align: left;
        }
        &:lang(ar) {
          text-align: right;
        }
      }
      svg {
        &.active {
          cursor: pointer;
          pointer-events: auto;
          path {
            fill: ${theme.colours.newOutline};
          }
        }
      }
    }
  }

  .action_container {
    .add {
      padding: 5px 16px;
    }
    .download {
      width: 161px;
      padding: 0;
    }
    button {
      border-radius: 8px;
      height: 32px;
      font-size: 14px;
      text-align: initial;
      font-family: ${theme.fonts.Medium};
      font-weight: 400;
      background-color: #242424 !important;
      span {
        font-size: 14px;
        line-height: 20px;
      }
      @media (max-width: 767px) {
        padding: 0 12px;
      }
      span.mantine-Button-icon {
        margin: 0;
        svg {
          width: 17px;
        }
      }
      &.add {
        background-color: ${theme.colours.blackText};
      }
      &.addTeam {
        background-color: ${theme.colours.blackText};
      }
      &.add.plus {
        @media (max-width: 767px) {
          padding: 0;
          width: 40px;
          height: 40px;
          display: block;
          font-size: 20px;
        }
        @media (min-width: 768px) {
          display: none;
        }
      }
      &.add_group {
        background-color: ${theme.colours.white};
        color: ${theme.colours.black};
        & > div {
          gap: 7px;
        }
      }
    }
    @media (max-width: 767px) {
      width: auto;
    }
  }
`;

export const SelectWrapper = styled.div`
  flex: 0 1 auto;
  flex-shrink: 0;

  label {
    span {
      color: ${theme.colours.error};
      font-size: 15px;
    }
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.black};
      margin-bottom: 0 !important;
      padding-inline-start: 12px;
      display: inline-block;
    }
  }
  .mantine-Input-icon {
    width: 24px;
  }

  .mantine-Select-rightSection {
    display: none !important;
  }

  .listOptions {
    .mantine-Select-dropdown {
      width: 300px !important;
    }
  }
  .status-options {
    .mantine-Select-dropdown {
      width: 100px !important;
    }
  }
  .clients {
    .mantine-Select-dropdown {
      width: 150px !important;
    }
  }
  .mantine-Input-rightSection {
    color: #666666;
    &:lang(en) {
      margin-right: 4px;
      margin-left: unset;
    }
    &:lang(ar) {
      margin-right: unset;
      margin-left: 4px;
    }
  }

  .mantine-Select-root.hasError .mantine-Select-input {
    border: 1px solid ${theme.colours.error} !important;
  }
  .mantine-select-dropdown {
    /* width: 200px; */
  }

  .mantine-Select-root {
    min-width: 65px !important;
    cursor: pointer;
    input {
      height: 30px !important;
      min-height: 30px !important;
      width: 100%;
      padding-block: 0;
      border-radius: 8px;
      color: ${theme.colours.black};
      font-family: ${theme.fonts.Regular};
      font-size: 13px;
      padding: 4px 8px;
      background-color: white;
      padding-left: 15px;
      border: 0.5px solid ${theme.colours.newOutline};
      ::placeholder {
        color: #000000 !important;
      }
      &:lang(ar) {
        text-align: right;
      }
      &:focus {
        font-size: 13px;
      }
      &::placeholder {
        color: ${theme.colours.SpanishGray};
      }
    }
    .mantine-Input-icon {
      svg {
        color: #000000;
      }
    }
    .mantine-Select-rightSection {
      width: unset !important;
      &:lang(ar) {
        left: 0;
        right: auto;
      }
    }
  }
`;

export const RepliesFilterWrapper = styled.div`
  padding-right: 16px;
  .btn-date {
    background-color: #f5f5f5 !important;
    color: #000000;
    border-radius: 8px;
    width: 66px;
    height: 30px;
    font-size: 14px;
    padding: 4px 2px 2px 5px;
    span.name {
      width: 36px;
      height: 16px;
      overflow: hidden;
    }
    svg {
      color: #666666;
    }
  }
  .date-filter {
    @media (max-width: 767px) {
      right: -110px;
    }
  }
  .mantine-DateInput-root {
    margin-top: 0;
  }
  .date-filter {
    position: absolute;
    top: 37px;
    background-color: white;
    display: flex;
    flex-direction: column;
    width: 195px;
    border-radius: 8px;
    border: 1px solid rgb(200, 200, 200);
    border-bottom: 1px solid #d4d4d4;
    padding: 8px 12px;
    z-index: 3;
    @media (max-width: 767px) {
      right: 0;
    }
    label {
      font-size: 14px;
      line-height: 22px;
      font-family: ${theme.fonts.Regular};
    }
    input {
      background-color: #fafafa;
      &::placeholder {
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        color: #969696;
      }
    }
  }
  .meeting-types,
  .Destination-options {
    .mantine-Select-dropdown {
      width: 150px !important;
    }
  }
  .clear-option {
    color: ${theme.colours.mainBlue} !important;
    border-top: 1px solid #e2e2e2 !important;
    margin-top: 4px !important;
    padding-top: 8px !important;
    font-size: 14px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding: 8px 12px !important;
    cursor: pointer !important;
    background-color: transparent !important;
    border: none !important;
    position: sticky !important;
    bottom: 0 !important;
    background-color: white !important;
    z-index: 1 !important;
  }

  .clear-date {
    cursor: pointer;
    background-color: transparent;
    border: none;
    color: ${theme.colours.mainBlue};
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;
